module.exports = __webpack_public_path__ + "static/media/logo-words.4ea9a6b5.png";